<template>
    <GChart
        v-if="valores_entradas_vendidas_grafica"
        type="PieChart"
        :data="valores_entradas_vendidas_grafica"
        :options="chartOptions"
    />
</template>

<script>
    export default {
        props: ['event_id', 'taquillero_id', 'sesion_id'],
        data() {
            return {
                valores_entradas_vendidas_grafica : null,
                chartOptions: {
                    height: 250,
                    chartArea:{width:'100%'}
                }
            }
        },
        watch: {
            event_id() {
                this.getTotalEntradas();
            },
            taquillero_id() {
                this.getTotalEntradas();
            },
            sesion_id() {
                this.getTotalEntradas();
            }
        },
        created() {
            this.getTotalEntradas();
        },
        methods: {
            getTotalEntradas() {
                const params = {
                    filters: {
                        taquillero_id: this.taquillero_id,
                        sesion_id: this.sesion_id
                    },
                    evento_id: this.event_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.informe.total-entradas-vendidas'), params).then(res => {
                    this.valores_entradas_vendidas_grafica = res.data;
                });
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        }
    }
</script>